var items = {
  "block.minecraft.air": "loft",
  "block.minecraft.stone": "steen",
  "block.minecraft.granite": "granit",
  "block.minecraft.polished_granite": "poléierte granit",
  "block.minecraft.diorite": "diorit",
  "block.minecraft.polished_diorite": "poléierten diorit",
  "block.minecraft.andesite": "andesit",
  "block.minecraft.polished_andesite": "poléierten andesit",
  "block.minecraft.grass_block": "gras",
  "block.minecraft.dirt": "äerd",
  "block.minecraft.coarse_dirt": "graff äerd",
  "block.minecraft.podzol": "podsol",
  "block.minecraft.crimson_nylium": "karmesin nylium",
  "block.minecraft.warped_nylium": "verduerwenen nylium",
  "block.minecraft.cobblestone": "brochsteen",
  "block.minecraft.oak_planks": "eechenholzbrieder",
  "block.minecraft.spruce_planks": "fiichtenholzbrieder",
  "block.minecraft.birch_planks": "bierkenholzbrieder",
  "block.minecraft.jungle_planks": "tropenholzbrieder",
  "block.minecraft.acacia_planks": "akazienholzbrieder",
  "block.minecraft.dark_oak_planks": "schwaarzeechenholzbrieder",
  "block.minecraft.crimson_planks": "karmesinbrieder",
  "block.minecraft.warped_planks": "verduerwe brieder",
  "block.minecraft.oak_sapling": "eechesetzlek",
  "block.minecraft.spruce_sapling": "fiichtesetzlek",
  "block.minecraft.birch_sapling": "bierkesetzlek",
  "block.minecraft.jungle_sapling": "tropesetzlek",
  "block.minecraft.acacia_sapling": "akaziesetzlek",
  "block.minecraft.dark_oak_sapling": "schwaarzeechesetzlek",
  "block.minecraft.bedrock": "grondsteen",
  "block.minecraft.sand": "sand",
  "block.minecraft.red_sand": "roude sand",
  "block.minecraft.gravel": "kräsi",
  "block.minecraft.gold_ore": "goldäerz",
  "block.minecraft.iron_ore": "eisenäerz",
  "block.minecraft.coal_ore": "steekuel",
  "block.minecraft.nether_gold_ore": "nethergoldäerz",
  "block.minecraft.oak_log": "eechestamm",
  "block.minecraft.spruce_log": "fiichtestamm",
  "block.minecraft.birch_log": "bierkestamm",
  "block.minecraft.jungle_log": "tropenholzstamm",
  "block.minecraft.acacia_log": "akaziëstamm",
  "block.minecraft.dark_oak_log": "schwaarzeechestamm",
  "block.minecraft.crimson_stem": "karmesinstill",
  "block.minecraft.warped_stem": "verduerwene stamm",
  "block.minecraft.stripped_oak_log": "eechestamm ouni schuel",
  "block.minecraft.stripped_spruce_log": "fiichtestamm ouni schuel",
  "block.minecraft.stripped_birch_log": "bierkestamm ouni schuel",
  "block.minecraft.stripped_jungle_log": "tropenholzstamm ouni schuel",
  "block.minecraft.stripped_acacia_log": "akaziëstamm ouni schuel",
  "block.minecraft.stripped_dark_oak_log": "schwaarzeechestamm ouni schuel",
  "block.minecraft.stripped_crimson_stem": "geschielte karmesinstill",
  "block.minecraft.stripped_warped_stem": "geschielten verduerwenen stamm",
  "block.minecraft.stripped_oak_wood": "eechenholz ouni schuel",
  "block.minecraft.stripped_spruce_wood": "fiichtenholz ouni schuel",
  "block.minecraft.stripped_birch_wood": "bierkenholz ouni schuel",
  "block.minecraft.stripped_jungle_wood": "tropenholz ouni schuel",
  "block.minecraft.stripped_acacia_wood": "akazienholz ouni schuel",
  "block.minecraft.stripped_dark_oak_wood": "schwaarzeechenholz ouni schuel",
  "block.minecraft.stripped_crimson_hyphae": "geschielte karmesinhyphen",
  "block.minecraft.stripped_warped_hyphae": "geschielt verduerwen hyphen",
  "block.minecraft.oak_wood": "eechenholz",
  "block.minecraft.spruce_wood": "fiichtenholz",
  "block.minecraft.birch_wood": "bierkenholz",
  "block.minecraft.jungle_wood": "tropenholz",
  "block.minecraft.acacia_wood": "akazienholz",
  "block.minecraft.dark_oak_wood": "schwaarzeechenholz",
  "block.minecraft.crimson_hyphae": "karmesinhyphen",
  "block.minecraft.warped_hyphae": "verduerwen hyphen",
  "block.minecraft.oak_leaves": "eecheblieder",
  "block.minecraft.spruce_leaves": "fiichtennolen",
  "block.minecraft.birch_leaves": "bierkeblieder",
  "block.minecraft.jungle_leaves": "tropeblieder",
  "block.minecraft.acacia_leaves": "akazieblieder",
  "block.minecraft.dark_oak_leaves": "schwaarzeecheblieder",
  "block.minecraft.sponge": "schwamp",
  "block.minecraft.wet_sponge": "naasse schwamp",
  "block.minecraft.glass": "glas",
  "block.minecraft.lapis_ore": "lapislazuliäerz",
  "block.minecraft.lapis_block": "lapislazuliblock",
  "block.minecraft.dispenser": "verdeeler",
  "block.minecraft.sandstone": "sandsteen",
  "block.minecraft.chiseled_sandstone": "gemeesselte sandsteen",
  "block.minecraft.cut_sandstone": "geschniddene sandsteen",
  "block.minecraft.note_block": "nouteblock",
  "block.minecraft.powered_rail": "beschleunegungsschinn",
  "block.minecraft.detector_rail": "sensorschinn",
  "block.minecraft.sticky_piston": "pechege piston",
  "block.minecraft.cobweb": "spaweck",
  "block.minecraft.grass": "gras",
  "block.minecraft.fern": "far",
  "block.minecraft.dead_bush": "ofgestuerwene strauch",
  "block.minecraft.seagrass": "séigras",
  "block.minecraft.sea_pickle": "miereskornischong",
  "block.minecraft.piston": "piston",
  "block.minecraft.white_wool": "wäiss woll",
  "block.minecraft.orange_wool": "orange woll",
  "block.minecraft.magenta_wool": "magenta woll",
  "block.minecraft.light_blue_wool": "hellblo woll",
  "block.minecraft.yellow_wool": "giel woll",
  "block.minecraft.lime_wool": "hellgréng woll",
  "block.minecraft.pink_wool": "rosa woll",
  "block.minecraft.gray_wool": "gro woll",
  "block.minecraft.light_gray_wool": "hellgro woll",
  "block.minecraft.cyan_wool": "turquoise woll",
  "block.minecraft.purple_wool": "mof woll",
  "block.minecraft.blue_wool": "blo woll",
  "block.minecraft.brown_wool": "brong woll",
  "block.minecraft.green_wool": "gréng woll",
  "block.minecraft.red_wool": "rout woll",
  "block.minecraft.black_wool": "schwaarz woll",
  "block.minecraft.dandelion": "bettseechesch",
  "block.minecraft.poppy": "feierblumm",
  "block.minecraft.blue_orchid": "blo orchidee",
  "block.minecraft.allium": "allium",
  "block.minecraft.azure_bluet": "porzeläinsstäerchen",
  "block.minecraft.red_tulip": "rout tulp",
  "block.minecraft.orange_tulip": "orange tulp",
  "block.minecraft.white_tulip": "wäiss tulp",
  "block.minecraft.pink_tulip": "rosa tulp",
  "block.minecraft.oxeye_daisy": "margréitchen",
  "block.minecraft.cornflower": "karblumm",
  "block.minecraft.lily_of_the_valley": "meeréischen",
  "block.minecraft.wither_rose": "witherrous",
  "block.minecraft.brown_mushroom": "bronge champignon",
  "block.minecraft.red_mushroom": "roude champignon",
  "block.minecraft.crimson_fungus": "karmesin champignon",
  "block.minecraft.warped_fungus": "verduerwene champignon",
  "block.minecraft.crimson_roots": "karmesinwuerzelen",
  "block.minecraft.warped_roots": "verduerwe wuerzelen",
  "block.minecraft.nether_sprouts": "nethersprossen",
  "block.minecraft.weeping_vines": "trauerlianen",
  "block.minecraft.twisting_vines": "wéckellianen",
  "block.minecraft.sugar_cane": "zockerrouer",
  "block.minecraft.kelp": "alg",
  "block.minecraft.bamboo": "bambus",
  "block.minecraft.gold_block": "goldblock",
  "block.minecraft.iron_block": "eiseblock",
  "block.minecraft.oak_slab": "eechenholzplack",
  "block.minecraft.spruce_slab": "fiichtenholzplack",
  "block.minecraft.birch_slab": "bierkenholzplack",
  "block.minecraft.jungle_slab": "tropenholzplack",
  "block.minecraft.acacia_slab": "akazienholzplack",
  "block.minecraft.dark_oak_slab": "schwaarzeechenholzplack",
  "block.minecraft.crimson_slab": "karmesinplack",
  "block.minecraft.warped_slab": "verduerwe plack",
  "block.minecraft.stone_slab": "steeplack",
  "block.minecraft.smooth_stone_slab": "glat steeplack",
  "block.minecraft.sandstone_slab": "sandsteeplack",
  "block.minecraft.cut_sandstone_slab": "geschnidde sandsteeplack",
  "block.minecraft.petrified_oak_slab": "verstengert eechenholzplack",
  "block.minecraft.cobblestone_slab": "brochsteeplack",
  "block.minecraft.brick_slab": "zilleplack",
  "block.minecraft.stone_brick_slab": "steenzilleplack",
  "block.minecraft.nether_brick_slab": "netherzilleplack",
  "block.minecraft.quartz_slab": "quarzplack",
  "block.minecraft.red_sandstone_slab": "rout sandsteeplack",
  "block.minecraft.cut_red_sandstone_slab": "geschnidde rout sandsteeplack",
  "block.minecraft.purpur_slab": "purpurträpplek",
  "block.minecraft.prismarine_slab": "prismarineplack",
  "block.minecraft.prismarine_brick_slab": "prismarinezilleplack",
  "block.minecraft.dark_prismarine_slab": "donkel prismarineplack",
  "block.minecraft.smooth_quartz": "glate quarzblock",
  "block.minecraft.smooth_red_sandstone": "glate roude sandsteen",
  "block.minecraft.smooth_sandstone": "glate sandsteen",
  "block.minecraft.smooth_stone": "glate steen",
  "block.minecraft.bricks": "zillen",
  "block.minecraft.tnt": "tnt",
  "block.minecraft.bookshelf": "bicherregal",
  "block.minecraft.mossy_cobblestone": "bemoosste brochsteen",
  "block.minecraft.obsidian": "obsidian",
  "block.minecraft.torch": "fakel",
  "block.minecraft.end_rod": "endstaf",
  "block.minecraft.chorus_plant": "chorusplanz",
  "block.minecraft.chorus_flower": "chorusbléi",
  "block.minecraft.purpur_block": "purpurblock",
  "block.minecraft.purpur_pillar": "purpursail",
  "block.minecraft.purpur_stairs": "purpurtrap",
  "block.minecraft.spawner": "spawner",
  "block.minecraft.oak_stairs": "eechenholztrap",
  "block.minecraft.chest": "këscht",
  "block.minecraft.diamond_ore": "diamantäerz",
  "block.minecraft.diamond_block": "diamantblock",
  "block.minecraft.crafting_table": "wierkbänk",
  "block.minecraft.farmland": "feld",
  "block.minecraft.furnace": "uewen",
  "block.minecraft.ladder": "leeder",
  "block.minecraft.rail": "schinn",
  "block.minecraft.cobblestone_stairs": "brochsteentrap",
  "block.minecraft.lever": "hiewel",
  "block.minecraft.stone_pressure_plate": "steendrockplack",
  "block.minecraft.oak_pressure_plate": "eechenholzdrockplack",
  "block.minecraft.spruce_pressure_plate": "fiichtenholzdrockplack",
  "block.minecraft.birch_pressure_plate": "bierkenholzdrockplack",
  "block.minecraft.jungle_pressure_plate": "tropenholzdrockplack",
  "block.minecraft.acacia_pressure_plate": "akazienholzdrockplack",
  "block.minecraft.dark_oak_pressure_plate": "schwaarzeechenholzdrockplack",
  "block.minecraft.crimson_pressure_plate": "karmesindrockplack",
  "block.minecraft.warped_pressure_plate": "verduerwen drockplack",
  "block.minecraft.polished_blackstone_pressure_plate": "poléiert schwaarzsteendrockplack",
  "block.minecraft.redstone_ore": "redstoneäerz",
  "block.minecraft.redstone_torch": "redstonefakel",
  "block.minecraft.snow": "schnéi",
  "block.minecraft.ice": "äis",
  "block.minecraft.snow_block": "schnéiblock",
  "block.minecraft.cactus": "kaktus",
  "block.minecraft.clay": "toun",
  "block.minecraft.jukebox": "plackespiller",
  "block.minecraft.oak_fence": "eechenholzzonk",
  "block.minecraft.spruce_fence": "fiichtenholzzonk",
  "block.minecraft.birch_fence": "bierkenholzzonk",
  "block.minecraft.jungle_fence": "tropenholzzonk",
  "block.minecraft.acacia_fence": "akazienholzzonk",
  "block.minecraft.dark_oak_fence": "schwaarzeechenholzzonk",
  "block.minecraft.crimson_fence": "karmesinzonk",
  "block.minecraft.warped_fence": "verduerwenen zonk",
  "block.minecraft.pumpkin": "kürbis",
  "block.minecraft.carved_pumpkin": "geschnëtzte kürbis",
  "block.minecraft.netherrack": "netherrack",
  "block.minecraft.soul_sand": "séilesand",
  "block.minecraft.soul_soil": "séilebuedem",
  "block.minecraft.basalt": "basalt",
  "block.minecraft.polished_basalt": "poléierte basalt",
  "block.minecraft.soul_torch": "séilefakel",
  "block.minecraft.glowstone": "glowstone",
  "block.minecraft.jack_o_lantern": "kürbislanter",
  "block.minecraft.oak_trapdoor": "eechenholzklappdier",
  "block.minecraft.spruce_trapdoor": "fiichtenholzklappdier",
  "block.minecraft.birch_trapdoor": "bierkenholzklappdier",
  "block.minecraft.jungle_trapdoor": "tropenholzklappdier",
  "block.minecraft.acacia_trapdoor": "akazienholzklappdier",
  "block.minecraft.dark_oak_trapdoor": "schwaarzeechenholzklappdier",
  "block.minecraft.crimson_trapdoor": "karmesinklappdier",
  "block.minecraft.warped_trapdoor": "verduerwen klappdier",
  "block.minecraft.infested_stone": "befalene steen",
  "block.minecraft.infested_cobblestone": "befalene brochsteen",
  "block.minecraft.infested_stone_bricks": "befale steenzillen",
  "block.minecraft.infested_mossy_stone_bricks": "befale bemoosste steenzillen",
  "block.minecraft.infested_cracked_stone_bricks": "befale rësseg steenzillen",
  "block.minecraft.infested_chiseled_stone_bricks": "befale gemeesselt steenzillen",
  "block.minecraft.stone_bricks": "steenzillen",
  "block.minecraft.mossy_stone_bricks": "bemoosste steenzillen",
  "block.minecraft.cracked_stone_bricks": "rësseg steenzillen",
  "block.minecraft.chiseled_stone_bricks": "gemeesselt steenzillen",
  "block.minecraft.brown_mushroom_block": "bronge champignonblock",
  "block.minecraft.red_mushroom_block": "roude champignonblock",
  "block.minecraft.mushroom_stem": "champignongsstill",
  "block.minecraft.iron_bars": "eisegitter",
  "block.minecraft.chain": "verketten",
  "block.minecraft.glass_pane": "glasscheif",
  "block.minecraft.melon": "meloun",
  "block.minecraft.vine": "lianen",
  "block.minecraft.oak_fence_gate": "eechenholzzonkpaart",
  "block.minecraft.spruce_fence_gate": "fiichtenholzzonkpaart",
  "block.minecraft.birch_fence_gate": "bierkenholzzonkpaart",
  "block.minecraft.jungle_fence_gate": "tropenholzzonkpaart",
  "block.minecraft.acacia_fence_gate": "akazienholzzonkpaart",
  "block.minecraft.dark_oak_fence_gate": "schwaarzeechenholzzonkpaart",
  "block.minecraft.crimson_fence_gate": "karmesinzonkpaart",
  "block.minecraft.warped_fence_gate": "verduerwen zonkpaart",
  "block.minecraft.brick_stairs": "zillentrap",
  "block.minecraft.stone_brick_stairs": "steenzillentrap",
  "block.minecraft.mycelium": "pilzgeflecht",
  "block.minecraft.lily_pad": "séirous",
  "block.minecraft.nether_bricks": "netherzillen",
  "block.minecraft.cracked_nether_bricks": "rësseg netherzillen",
  "block.minecraft.chiseled_nether_bricks": "gemeesselt netherzillen",
  "block.minecraft.nether_brick_fence": "netherzillenzonk",
  "block.minecraft.nether_brick_stairs": "netherzillentrap",
  "block.minecraft.enchanting_table": "zauberdësch",
  "block.minecraft.end_portal_frame": "endportalkader",
  "block.minecraft.end_stone": "endsteen",
  "block.minecraft.end_stone_bricks": "endsteenzillen",
  "block.minecraft.dragon_egg": "draachenee",
  "block.minecraft.redstone_lamp": "redstoneluucht",
  "block.minecraft.sandstone_stairs": "sandsteentrap",
  "block.minecraft.emerald_ore": "smaragdäerz",
  "block.minecraft.ender_chest": "enderkëscht",
  "block.minecraft.tripwire_hook": "krop",
  "block.minecraft.emerald_block": "smaragdblock",
  "block.minecraft.spruce_stairs": "fiichtenholztrap",
  "block.minecraft.birch_stairs": "bierkenholztrap",
  "block.minecraft.jungle_stairs": "tropenholztrap",
  "block.minecraft.crimson_stairs": "karmesintrap",
  "block.minecraft.warped_stairs": "verduerwen trap",
  "block.minecraft.command_block": "befehlsblock",
  "block.minecraft.beacon": "liichtfeier",
  "block.minecraft.cobblestone_wall": "brochsteemauer",
  "block.minecraft.mossy_cobblestone_wall": "bemoosste brochsteemauer",
  "block.minecraft.brick_wall": "zillemauer",
  "block.minecraft.prismarine_wall": "prismarinemauer",
  "block.minecraft.red_sandstone_wall": "rout standsteemauer",
  "block.minecraft.mossy_stone_brick_wall": "bemooste steenzillemauer",
  "block.minecraft.granite_wall": "granitmauer",
  "block.minecraft.stone_brick_wall": "steenzillemauer",
  "block.minecraft.nether_brick_wall": "netherzillemauer",
  "block.minecraft.andesite_wall": "andesitmauer",
  "block.minecraft.red_nether_brick_wall": "rout netherzillemauer",
  "block.minecraft.sandstone_wall": "sandsteemauer",
  "block.minecraft.end_stone_brick_wall": "endsteenzillemauer",
  "block.minecraft.diorite_wall": "dioritmauer",
  "block.minecraft.blackstone_wall": "schwaarzsteemauer",
  "block.minecraft.polished_blackstone_wall": "poléiert schwaarzsteenmauer",
  "block.minecraft.polished_blackstone_brick_wall": "poléiert schwarzsteenzillemauer",
  "block.minecraft.stone_button": "steeknäppchen",
  "block.minecraft.oak_button": "eechenholzknäppchen",
  "block.minecraft.spruce_button": "fiichtenholzknäppchen",
  "block.minecraft.birch_button": "bierkenholzknäppchen",
  "block.minecraft.jungle_button": "tropenholzknäppchen",
  "block.minecraft.acacia_button": "akazienholzknäppchen",
  "block.minecraft.dark_oak_button": "schwaarzeechenholzknäppchen",
  "block.minecraft.crimson_button": "karmesinknäppchen",
  "block.minecraft.warped_button": "verduerwenen knäppchen",
  "block.minecraft.polished_blackstone_button": "poléierte schwaarzsteeknäppchen",
  "block.minecraft.anvil": "amboss",
  "block.minecraft.chipped_anvil": "ugeschloenen amboss",
  "block.minecraft.damaged_anvil": "beschiedegten amboss",
  "block.minecraft.trapped_chest": "falekëscht",
  "block.minecraft.light_weighted_pressure_plate": "liicht gewiichtet drockplack",
  "block.minecraft.heavy_weighted_pressure_plate": "schwéier gewiichtet drockplack",
  "block.minecraft.daylight_detector": "liichtsensor",
  "block.minecraft.redstone_block": "redstoneblock",
  "block.minecraft.nether_quartz_ore": "netherquarzäerz",
  "block.minecraft.hopper": "triichter",
  "block.minecraft.chiseled_quartz_block": "gemeesselte quarzblock",
  "block.minecraft.quartz_block": "quarzblock",
  "block.minecraft.quartz_bricks": "quarzzillen",
  "block.minecraft.quartz_pillar": "quarzsail",
  "block.minecraft.quartz_stairs": "quarztrap",
  "block.minecraft.activator_rail": "aktivéierungsschinn",
  "block.minecraft.dropper": "spender",
  "block.minecraft.white_terracotta": "wäiss keramik",
  "block.minecraft.orange_terracotta": "orange keramik",
  "block.minecraft.magenta_terracotta": "magenta keramik",
  "block.minecraft.light_blue_terracotta": "hellblo keramik",
  "block.minecraft.yellow_terracotta": "giel keramik",
  "block.minecraft.lime_terracotta": "hellgréng keramik",
  "block.minecraft.pink_terracotta": "rosa keramik",
  "block.minecraft.gray_terracotta": "gro keramik",
  "block.minecraft.light_gray_terracotta": "hellgro keramik",
  "block.minecraft.cyan_terracotta": "turquoise keramik",
  "block.minecraft.purple_terracotta": "mof keramik",
  "block.minecraft.blue_terracotta": "blo keramik",
  "block.minecraft.brown_terracotta": "brong keramik",
  "block.minecraft.green_terracotta": "gréng keramik",
  "block.minecraft.red_terracotta": "rout keramik",
  "block.minecraft.black_terracotta": "schwaarz keramik",
  "block.minecraft.barrier": "barrière",
  "block.minecraft.iron_trapdoor": "eiseklappdier",
  "block.minecraft.hay_block": "bott",
  "block.minecraft.white_carpet": "wäissen teppech",
  "block.minecraft.orange_carpet": "orangen teppech",
  "block.minecraft.magenta_carpet": "magentaen teppech",
  "block.minecraft.light_blue_carpet": "hellbloen teppech",
  "block.minecraft.yellow_carpet": "gielen teppech",
  "block.minecraft.lime_carpet": "hellgréngen teppech",
  "block.minecraft.pink_carpet": "rosaen teppech",
  "block.minecraft.gray_carpet": "groen teppech",
  "block.minecraft.light_gray_carpet": "hellgroen teppech",
  "block.minecraft.cyan_carpet": "turquoisen teppech",
  "block.minecraft.purple_carpet": "mofen teppech",
  "block.minecraft.blue_carpet": "bloen teppech",
  "block.minecraft.brown_carpet": "brongen teppech",
  "block.minecraft.green_carpet": "gréngen teppech",
  "block.minecraft.red_carpet": "rouden teppech",
  "block.minecraft.black_carpet": "schwaarzen teppech",
  "block.minecraft.terracotta": "keramik",
  "block.minecraft.coal_block": "kueleblock",
  "block.minecraft.packed_ice": "packäis",
  "block.minecraft.acacia_stairs": "akazienholztrap",
  "block.minecraft.dark_oak_stairs": "schwaarzeechenholztrap",
  "block.minecraft.slime_block": "schläimblock",
  "block.minecraft.grass_path": "graswee",
  "block.minecraft.sunflower": "sonneblumm",
  "block.minecraft.lilac": "neelchesblumm",
  "block.minecraft.rose_bush": "rousenheck",
  "block.minecraft.peony": "päischtrous",
  "block.minecraft.tall_grass": "héicht gras",
  "block.minecraft.large_fern": "grousse far",
  "block.minecraft.white_stained_glass": "wäisst glas",
  "block.minecraft.orange_stained_glass": "orange glas",
  "block.minecraft.magenta_stained_glass": "magenta glas",
  "block.minecraft.light_blue_stained_glass": "hellblot glas",
  "block.minecraft.yellow_stained_glass": "gielt glas",
  "block.minecraft.lime_stained_glass": "hellgréngt glas",
  "block.minecraft.pink_stained_glass": "rosat glas",
  "block.minecraft.gray_stained_glass": "grot glas",
  "block.minecraft.light_gray_stained_glass": "hellgrot glas",
  "block.minecraft.cyan_stained_glass": "turquoiset glas",
  "block.minecraft.purple_stained_glass": "moft glas",
  "block.minecraft.blue_stained_glass": "blot glas",
  "block.minecraft.brown_stained_glass": "brongt glas",
  "block.minecraft.green_stained_glass": "gréngt glas",
  "block.minecraft.red_stained_glass": "rout glas",
  "block.minecraft.black_stained_glass": "schwaarzt glas",
  "block.minecraft.white_stained_glass_pane": "wäiss glasscheif",
  "block.minecraft.orange_stained_glass_pane": "orange glasscheif",
  "block.minecraft.magenta_stained_glass_pane": "magenta glasscheif",
  "block.minecraft.light_blue_stained_glass_pane": "hellblo glasscheif",
  "block.minecraft.yellow_stained_glass_pane": "giel glasscheif",
  "block.minecraft.lime_stained_glass_pane": "hellgréng glasscheif",
  "block.minecraft.pink_stained_glass_pane": "rosa glasscheif",
  "block.minecraft.gray_stained_glass_pane": "gro glasscheif",
  "block.minecraft.light_gray_stained_glass_pane": "hellgro glasscheif",
  "block.minecraft.cyan_stained_glass_pane": "turquoise glasscheif",
  "block.minecraft.purple_stained_glass_pane": "mof glasscheif",
  "block.minecraft.blue_stained_glass_pane": "blo glasscheif",
  "block.minecraft.brown_stained_glass_pane": "brong glasscheif",
  "block.minecraft.green_stained_glass_pane": "gréng glasscheif",
  "block.minecraft.red_stained_glass_pane": "roud glasscheif",
  "block.minecraft.black_stained_glass_pane": "schwaarz glasscheif",
  "block.minecraft.prismarine": "prismarine",
  "block.minecraft.prismarine_bricks": "prismarinezillen",
  "block.minecraft.dark_prismarine": "donkele prismarine",
  "block.minecraft.prismarine_stairs": "prismarinetrap",
  "block.minecraft.prismarine_brick_stairs": "prismarinezillentrap",
  "block.minecraft.dark_prismarine_stairs": "donkel prismarinetrap",
  "block.minecraft.sea_lantern": "séilanter",
  "block.minecraft.red_sandstone": "roude sandsteen",
  "block.minecraft.chiseled_red_sandstone": "gemeesselte roude sandsteen",
  "block.minecraft.cut_red_sandstone": "geschniddene roude sandsteen",
  "block.minecraft.red_sandstone_stairs": "rout sandsteentrap",
  "block.minecraft.repeating_command_block": "widderhuelungs befehlsblock",
  "block.minecraft.chain_command_block": "kette befehlsblock",
  "block.minecraft.magma_block": "magmablock",
  "block.minecraft.nether_wart_block": "netherwaarzelblock",
  "block.minecraft.warped_wart_block": "verduerwene waarzelblock",
  "block.minecraft.red_nether_bricks": "roud netherzillen",
  "block.minecraft.bone_block": "schankeblock",
  "block.minecraft.structure_void": "konstruktiounsvakuum",
  "block.minecraft.observer": "observateur",
  "block.minecraft.shulker_box": "shulkerkëscht",
  "block.minecraft.white_shulker_box": "wäiss shulkerkëscht",
  "block.minecraft.orange_shulker_box": "orange shulkerkëscht",
  "block.minecraft.magenta_shulker_box": "magenta shulkerkëscht",
  "block.minecraft.light_blue_shulker_box": "hellblo shulkerkëscht",
  "block.minecraft.yellow_shulker_box": "giel shulkerkëscht",
  "block.minecraft.lime_shulker_box": "hellgréng shulkerkëscht",
  "block.minecraft.pink_shulker_box": "rosa shulkerkëscht",
  "block.minecraft.gray_shulker_box": "gro shulkerkëscht",
  "block.minecraft.light_gray_shulker_box": "hellgro shulkerkëscht",
  "block.minecraft.cyan_shulker_box": "turquoise shulkerkëscht",
  "block.minecraft.purple_shulker_box": "mof shulkerkëscht",
  "block.minecraft.blue_shulker_box": "blo shulkerkëscht",
  "block.minecraft.brown_shulker_box": "brong shulkerkëscht",
  "block.minecraft.green_shulker_box": "gréng shulkerkëscht",
  "block.minecraft.red_shulker_box": "rout shulkerkëscht",
  "block.minecraft.black_shulker_box": "schwaarz shulkerkëscht",
  "block.minecraft.white_glazed_terracotta": "glaséiert wäiss keramik",
  "block.minecraft.orange_glazed_terracotta": "glaséiert orange keramik",
  "block.minecraft.magenta_glazed_terracotta": "glaséiert magenta keramik",
  "block.minecraft.light_blue_glazed_terracotta": "glaséiert hellblo keramik",
  "block.minecraft.yellow_glazed_terracotta": "glaséiert giel keramik",
  "block.minecraft.lime_glazed_terracotta": "glaséiert hellgréng keramik",
  "block.minecraft.pink_glazed_terracotta": "glaséiert rosa keramik",
  "block.minecraft.gray_glazed_terracotta": "glaséiert gro keramik",
  "block.minecraft.light_gray_glazed_terracotta": "glaséiert hellgro keramik",
  "block.minecraft.cyan_glazed_terracotta": "glaséiert turquoise keramik",
  "block.minecraft.purple_glazed_terracotta": "glaséiert mof keramik",
  "block.minecraft.blue_glazed_terracotta": "glaséiert blo keramik",
  "block.minecraft.brown_glazed_terracotta": "glaséiert brong keramik",
  "block.minecraft.green_glazed_terracotta": "glaséiert gréng keramik",
  "block.minecraft.red_glazed_terracotta": "glaséiert rout keramik",
  "block.minecraft.black_glazed_terracotta": "glaséiert schwaarz keramik",
  "block.minecraft.white_concrete": "wäisse bëtong",
  "block.minecraft.orange_concrete": "orangë bëtong",
  "block.minecraft.magenta_concrete": "magentae bëtong",
  "block.minecraft.light_blue_concrete": "hellbloe bëtong",
  "block.minecraft.yellow_concrete": "giele bëtong",
  "block.minecraft.lime_concrete": "hellgrénge bëtong",
  "block.minecraft.pink_concrete": "rosae bëtong",
  "block.minecraft.gray_concrete": "groe bëtong",
  "block.minecraft.light_gray_concrete": "hellgroe bëtong",
  "block.minecraft.cyan_concrete": "turquoise bëtong",
  "block.minecraft.purple_concrete": "mofe bëtong",
  "block.minecraft.blue_concrete": "bloe bëtong",
  "block.minecraft.brown_concrete": "bronge bëtong",
  "block.minecraft.green_concrete": "grénge bëtong",
  "block.minecraft.red_concrete": "roude bëtong",
  "block.minecraft.black_concrete": "schwaarze bëtong",
  "block.minecraft.white_concrete_powder": "wäissen zement",
  "block.minecraft.orange_concrete_powder": "orangen zement",
  "block.minecraft.magenta_concrete_powder": "magentaen zement",
  "block.minecraft.light_blue_concrete_powder": "hellbloen zement",
  "block.minecraft.yellow_concrete_powder": "gielen zement",
  "block.minecraft.lime_concrete_powder": "hellgréngen zement",
  "block.minecraft.pink_concrete_powder": "rosaen zement",
  "block.minecraft.gray_concrete_powder": "groen zement",
  "block.minecraft.light_gray_concrete_powder": "hellgroen zement",
  "block.minecraft.cyan_concrete_powder": "turquoisen zement",
  "block.minecraft.purple_concrete_powder": "mofen zement",
  "block.minecraft.blue_concrete_powder": "bloen zement",
  "block.minecraft.brown_concrete_powder": "brongen zement",
  "block.minecraft.green_concrete_powder": "gréngen zement",
  "block.minecraft.red_concrete_powder": "rouden zement",
  "block.minecraft.black_concrete_powder": "schwaarzen zement",
  "block.minecraft.turtle_egg": "schildkrötenee",
  "block.minecraft.dead_tube_coral_block": "ofgestuerwene uergelkoralleblock",
  "block.minecraft.dead_brain_coral_block": "ofgestuerwene hirkoralleblock",
  "block.minecraft.dead_bubble_coral_block": "ofgestuerwene blosekoralleblock",
  "block.minecraft.dead_fire_coral_block": "ofgestuerwene féierkoralleblock",
  "block.minecraft.dead_horn_coral_block": "ofgestuerwene geweikoralleblock",
  "block.minecraft.tube_coral_block": "uergelkoralleblock",
  "block.minecraft.brain_coral_block": "hirkoralleblock",
  "block.minecraft.bubble_coral_block": "blosekoralleblock",
  "block.minecraft.fire_coral_block": "féierkoralleblock",
  "block.minecraft.horn_coral_block": "geweikoralleblock",
  "block.minecraft.tube_coral": "uergelkorall",
  "block.minecraft.brain_coral": "hirkorall",
  "block.minecraft.bubble_coral": "blosekorall",
  "block.minecraft.fire_coral": "féierkorall",
  "block.minecraft.horn_coral": "geweikorall",
  "block.minecraft.dead_brain_coral": "ofgestuerwe hirkorall",
  "block.minecraft.dead_bubble_coral": "ofgestuerwe blosekorall",
  "block.minecraft.dead_fire_coral": "ofgestuerwe féierkorall",
  "block.minecraft.dead_horn_coral": "ofgestuerwe geweikorall",
  "block.minecraft.dead_tube_coral": "ofgestuerwe uergelkorall",
  "block.minecraft.tube_coral_fan": "uergelkorallefächer",
  "block.minecraft.brain_coral_fan": "hirkorallefächer",
  "block.minecraft.bubble_coral_fan": "blosekorallefächer",
  "block.minecraft.fire_coral_fan": "féierkorallefächer",
  "block.minecraft.horn_coral_fan": "geweikorallefächer",
  "block.minecraft.dead_tube_coral_fan": "ofgestuerwene uergelkorallefächer",
  "block.minecraft.dead_brain_coral_fan": "ofgestuerwene hirkorallefächer",
  "block.minecraft.dead_bubble_coral_fan": "ofgestuerwene blosekorallefächer",
  "block.minecraft.dead_fire_coral_fan": "ofgestuerwene féierkorallefächer",
  "block.minecraft.dead_horn_coral_fan": "ofgestuerwene geweikorallefächer",
  "block.minecraft.blue_ice": "bloäis",
  "block.minecraft.conduit": "conduit",
  "block.minecraft.polished_granite_stairs": "poléiert granittrap",
  "block.minecraft.smooth_red_sandstone_stairs": "glat rout sandsteentrap",
  "block.minecraft.mossy_stone_brick_stairs": "bemooste steenzillentrap",
  "block.minecraft.polished_diorite_stairs": "poléiert diorittrap",
  "block.minecraft.mossy_cobblestone_stairs": "bemooste brochsteentrap",
  "block.minecraft.end_stone_brick_stairs": "endsteenzillentrap",
  "block.minecraft.stone_stairs": "steentrap",
  "block.minecraft.smooth_sandstone_stairs": "glat steentrap",
  "block.minecraft.smooth_quartz_stairs": "glat quarztrap",
  "block.minecraft.granite_stairs": "granittrap",
  "block.minecraft.andesite_stairs": "andesittrap",
  "block.minecraft.red_nether_brick_stairs": "rout netherzillentrap",
  "block.minecraft.polished_andesite_stairs": "poléiert andesittrap",
  "block.minecraft.diorite_stairs": "diorittrap",
  "block.minecraft.polished_granite_slab": "poléiert granitplack",
  "block.minecraft.smooth_red_sandstone_slab": "glat rout sandsteeplack",
  "block.minecraft.mossy_stone_brick_slab": "bemooste steenzilleplack",
  "block.minecraft.polished_diorite_slab": "poléiert dioritplack",
  "block.minecraft.mossy_cobblestone_slab": "bemooste brochsteeplack",
  "block.minecraft.end_stone_brick_slab": "endsteenzilleplack",
  "block.minecraft.smooth_sandstone_slab": "glat sandsteeplack",
  "block.minecraft.smooth_quartz_slab": "glat quarzplack",
  "block.minecraft.granite_slab": "granitplack",
  "block.minecraft.andesite_slab": "andesitplack",
  "block.minecraft.red_nether_brick_slab": "rout netherzilleplack",
  "block.minecraft.polished_andesite_slab": "poléiert andesitplack",
  "block.minecraft.diorite_slab": "dioritplack",
  "block.minecraft.scaffolding": "gerüst",
  "block.minecraft.iron_door": "eisendier",
  "block.minecraft.oak_door": "eechenholzdier",
  "block.minecraft.spruce_door": "fiichtenholzdier",
  "block.minecraft.birch_door": "bierkenholzdier",
  "block.minecraft.jungle_door": "tropenholzdier",
  "block.minecraft.acacia_door": "akazienholzdier",
  "block.minecraft.dark_oak_door": "schwaarzeechenholzdier",
  "block.minecraft.crimson_door": "karmesindier",
  "block.minecraft.warped_door": "verduerwen dier",
  "block.minecraft.repeater": "redstoneverstäerker",
  "block.minecraft.comparator": "redstonekomparator",
  "block.minecraft.structure_block": "konstruktiounsblock",
  "block.minecraft.jigsaw": "puzzleblock",
  "item.minecraft.turtle_helmet": "schildkrötenpanzer□□um kap:□+2 rüstung",
  "item.minecraft.scute": "schildkröteschupp",
  "item.minecraft.iron_shovel": "eiseschëpp□□an der haapthand:□+3.5 ugrëffsschued□-3 ugrëffsgeschwindegkeet",
  "item.minecraft.iron_pickaxe": "eisepickaaxt□□an der haapthand:□+3 ugrëffsschued□-2.8 ugrëffsgeschwindegkeet",
  "item.minecraft.iron_axe": "eisenaaxt□□an der haapthand:□+8 ugrëffsschued□-3.1 ugrëffsgeschwindegkeet",
  "item.minecraft.flint_and_steel": "briquet",
  "item.minecraft.apple": "apel",
  "item.minecraft.bow": "bou",
  "item.minecraft.arrow": "feil",
  "item.minecraft.coal": "kuel",
  "item.minecraft.charcoal": "holzkuel",
  "item.minecraft.diamond": "diamant",
  "item.minecraft.iron_ingot": "eisebarren",
  "item.minecraft.gold_ingot": "goldbarren",
  "item.minecraft.netherite_ingot": "netheritebarren",
  "item.minecraft.netherite_scrap": "netheritefragment",
  "item.minecraft.iron_sword": "eiseschwäert□□an der haapthand:□+5 ugrëffsschued□-2.4 ugrëffsgeschwindegkeet",
  "item.minecraft.wooden_sword": "holzschwäert□□an der haapthand:□+3 ugrëffsschued□-2.4 ugrëffsgeschwindegkeet",
  "item.minecraft.wooden_shovel": "holzschëpp□□an der haapthand:□+1.5 ugrëffsschued□-3 ugrëffsgeschwindegkeet",
  "item.minecraft.wooden_pickaxe": "holzpickaaxt□□an der haapthand:□+1 ugrëffsschued□-2.8 ugrëffsgeschwindegkeet",
  "item.minecraft.wooden_axe": "holzaaxt□□an der haapthand:□+6 ugrëffsschued□-3.2 ugrëffsgeschwindegkeet",
  "item.minecraft.stone_sword": "steeschwäert□□an der haapthand:□+4 ugrëffsschued□-2.4 ugrëffsgeschwindegkeet",
  "item.minecraft.stone_shovel": "steeschëpp□□an der haapthand:□+2.5 ugrëffsschued□-3 ugrëffsgeschwindegkeet",
  "item.minecraft.stone_pickaxe": "steepickaaxt□□an der haapthand:□+2 ugrëffsschued□-2.8 ugrëffsgeschwindegkeet",
  "item.minecraft.stone_axe": "steeaaxt□□an der haapthand:□+8 ugrëffsschued□-3.2 ugrëffsgeschwindegkeet",
  "item.minecraft.diamond_sword": "diamantschwäert□□an der haapthand:□+6 ugrëffsschued□-2.4 ugrëffsgeschwindegkeet",
  "item.minecraft.diamond_shovel": "diamantschëpp□□an der haapthand:□+4.5 ugrëffsschued□-3 ugrëffsgeschwindegkeet",
  "item.minecraft.diamond_pickaxe": "diamantpickaaxt□□an der haapthand:□+4 ugrëffsschued□-2.8 ugrëffsgeschwindegkeet",
  "item.minecraft.diamond_axe": "diamantaaxt□□an der haapthand:□+8 ugrëffsschued□-3 ugrëffsgeschwindegkeet",
  "item.minecraft.stick": "bengel",
  "item.minecraft.bowl": "schossel",
  "item.minecraft.mushroom_stew": "champignonszopp",
  "item.minecraft.golden_sword": "goldschwäert□□an der haapthand:□+3 ugrëffsschued□-2.4 ugrëffsgeschwindegkeet",
  "item.minecraft.golden_shovel": "goldschëpp□□an der haapthand:□+1.5 ugrëffsschued□-3 ugrëffsgeschwindegkeet",
  "item.minecraft.golden_pickaxe": "goldpickaaxt□□an der haapthand:□+1 ugrëffsschued□-2.8 ugrëffsgeschwindegkeet",
  "item.minecraft.golden_axe": "goldaaxt□□an der haapthand:□+6 ugrëffsschued□-3 ugrëffsgeschwindegkeet",
  "item.minecraft.netherite_sword": "netheriteschwäert□□an der haapthand:□+7 ugrëffsschued□-2.4 ugrëffsgeschwindegkeet",
  "item.minecraft.netherite_shovel": "netheriteschëpp□□an der haapthand:□+5.5 ugrëffsschued□-3 ugrëffsgeschwindegkeet",
  "item.minecraft.netherite_pickaxe": "netheritepickaaxt□□an der haapthand:□+5 ugrëffsschued□-2.8 ugrëffsgeschwindegkeet",
  "item.minecraft.netherite_axe": "netheriteaxt□□an der haapthand:□+9 ugrëffsschued□-3 ugrëffsgeschwindegkeet",
  "item.minecraft.string": "fuedem",
  "item.minecraft.feather": "fieder",
  "item.minecraft.gunpowder": "schéisspolver",
  "item.minecraft.wooden_hoe": "holzheel□□an der haapthand:□-3 ugrëffsgeschwindegkeet",
  "item.minecraft.stone_hoe": "steenheel□□an der haapthand:□-2 ugrëffsgeschwindegkeet",
  "item.minecraft.iron_hoe": "eisenheel□□an der haapthand:□-1 ugrëffsgeschwindegkeet",
  "item.minecraft.diamond_hoe": "diamantheel□□an der haapthand:",
  "item.minecraft.golden_hoe": "goldheel□□an der haapthand:□-3 ugrëffsgeschwindegkeet",
  "item.minecraft.netherite_hoe": "netheriteheel□□an der haapthand:",
  "item.minecraft.wheat_seeds": "weesskären",
  "item.minecraft.wheat": "weess",
  "item.minecraft.bread": "brout",
  "item.minecraft.leather_helmet": "liederskap□□um kap:□+1 rüstung",
  "item.minecraft.leather_chestplate": "liedersjackett□□um kierper:□+3 rüstung",
  "item.minecraft.leather_leggings": "liedersbox□□un de been:□+2 rüstung",
  "item.minecraft.leather_boots": "liedersstiwwelen□□un de féiss:□+1 rüstung",
  "item.minecraft.chainmail_helmet": "kettenhelm□□um kap:□+2 rüstung",
  "item.minecraft.chainmail_chestplate": "kettenhiem□□um kierper:□+5 rüstung",
  "item.minecraft.chainmail_leggings": "kettebox□□un de been:□+4 rüstung",
  "item.minecraft.chainmail_boots": "kettestiwwelen□□un de féiss:□+1 rüstung",
  "item.minecraft.iron_helmet": "eisenhelm□□um kap:□+2 rüstung",
  "item.minecraft.iron_chestplate": "eisebroschtpanzer□□um kierper:□+6 rüstung",
  "item.minecraft.iron_leggings": "eisebeeschutz□□un de been:□+5 rüstung",
  "item.minecraft.iron_boots": "eisestiwwelen□□un de féiss:□+2 rüstung",
  "item.minecraft.diamond_helmet": "diamanthelm□□um kap:□+3 rüstung□+2 rüstungshäert",
  "item.minecraft.diamond_chestplate": "diamantbroschtpanzer□□um kierper:□+8 rüstung□+2 rüstungshäert",
  "item.minecraft.diamond_leggings": "diamantbeenschutz□□un de been:□+6 rüstung□+2 rüstungshäert",
  "item.minecraft.diamond_boots": "diamantstiwwelen□□un de féiss:□+3 rüstung□+2 rüstungshäert",
  "item.minecraft.golden_helmet": "goldhelm□□um kap:□+2 rüstung",
  "item.minecraft.golden_chestplate": "goldbroschtpanzer□□um kierper:□+5 rüstung",
  "item.minecraft.golden_leggings": "goldbeeschutz□□un de been:□+3 rüstung",
  "item.minecraft.golden_boots": "goldstiwwelen□□un de féiss:□+1 rüstung",
  "item.minecraft.netherite_helmet": "netheritehelm□□um kap:□+3 rüstung□+3 rüstungshäert□+1 standfestegkeet",
  "item.minecraft.netherite_chestplate": "netheritebroschtpanzer□□um kierper:□+8 rüstung□+3 rüstungshäert□+1 standfestegkeet",
  "item.minecraft.netherite_leggings": "netheritebeeschutz□□un de been:□+6 rüstung□+3 rüstungshäert□+1 standfestegkeet",
  "item.minecraft.netherite_boots": "netheritestiwwelen□□un de féiss:□+3 rüstung□+3 rüstungshäert□+1 standfestegkeet",
  "item.minecraft.flint": "feiersteen",
  "item.minecraft.porkchop": "réit schwéngefleesch",
  "item.minecraft.cooked_porkchop": "gebrodent schwéngefleesch",
  "item.minecraft.painting": "bild",
  "item.minecraft.golden_apple": "gëllenen apel",
  "item.minecraft.enchanted_golden_apple": "verzauberte gëllenen apel",
  "block.minecraft.oak_sign": "eechenholzschëld",
  "block.minecraft.spruce_sign": "fiichtenholzschëld",
  "block.minecraft.birch_sign": "bierkenholzschëld",
  "block.minecraft.jungle_sign": "tropenholzschëld",
  "block.minecraft.acacia_sign": "akazienholzschëld",
  "block.minecraft.dark_oak_sign": "schwaarzeechenholzschëld",
  "block.minecraft.crimson_sign": "karmesinschëld",
  "block.minecraft.warped_sign": "verduerwend schëld",
  "item.minecraft.bucket": "eemer",
  "item.minecraft.water_bucket": "waassereemer",
  "item.minecraft.lava_bucket": "lavaeemer",
  "item.minecraft.minecart": "buggi",
  "item.minecraft.saddle": "suedel",
  "item.minecraft.redstone": "redstonestëbs",
  "item.minecraft.snowball": "schnéiball",
  "item.minecraft.oak_boat": "eechenholzboot",
  "item.minecraft.leather": "lieder",
  "item.minecraft.milk_bucket": "mëllecheemer",
  "item.minecraft.pufferfish_bucket": "kugelfëscheemer",
  "item.minecraft.salmon_bucket": "saumoneemer",
  "item.minecraft.cod_bucket": "cabillaudeemer",
  "item.minecraft.tropical_fish_bucket": "tropefëscheemer",
  "item.minecraft.brick": "zillen",
  "item.minecraft.clay_ball": "tounklompen",
  "block.minecraft.dried_kelp_block": "gedréchenten algeblock",
  "item.minecraft.paper": "pabeier",
  "item.minecraft.book": "buch",
  "item.minecraft.slime_ball": "schläimkugel",
  "item.minecraft.chest_minecart": "gidderbuggi",
  "item.minecraft.furnace_minecart": "ugedriwwene buggi",
  "item.minecraft.egg": "ee",
  "item.minecraft.compass": "kompass",
  "item.minecraft.fishing_rod": "aangel",
  "item.minecraft.clock": "auer",
  "item.minecraft.glowstone_dust": "glowstonestëbs",
  "item.minecraft.cod": "réie cabillaud",
  "item.minecraft.salmon": "réie saumon",
  "item.minecraft.tropical_fish": "tropefësch",
  "item.minecraft.pufferfish": "kugelfësch",
  "item.minecraft.cooked_cod": "gebrodene cabillaud",
  "item.minecraft.cooked_salmon": "gebrodene saumon",
  "item.minecraft.ink_sac": "tëntesak",
  "item.minecraft.red_dye": "roude fuerfstoff",
  "item.minecraft.green_dye": "grénge fuerfstoff",
  "item.minecraft.cocoa_beans": "kakaoboun",
  "item.minecraft.lapis_lazuli": "lapislazuli",
  "item.minecraft.purple_dye": "mofe fuerfstoff",
  "item.minecraft.cyan_dye": "turquoise fuerfstoff",
  "item.minecraft.light_gray_dye": "hellgroe fuerfstoff",
  "item.minecraft.gray_dye": "groe fuerfstoff",
  "item.minecraft.pink_dye": "rosa fuerfstoff",
  "item.minecraft.lime_dye": "hellgrénge fuerfstoff",
  "item.minecraft.yellow_dye": "giele fuerfstoff",
  "item.minecraft.light_blue_dye": "hellbloe fuerfstoff",
  "item.minecraft.magenta_dye": "magenta fuerfstoff",
  "item.minecraft.orange_dye": "orange fuerfstoff",
  "item.minecraft.bone_meal": "schankemiel",
  "item.minecraft.blue_dye": "bloe fuerfstoff",
  "item.minecraft.brown_dye": "bronge fuerfstoff",
  "item.minecraft.black_dye": "schwaarze fuerfstoff",
  "item.minecraft.white_dye": "wäisse fuerfstoff",
  "item.minecraft.bone": "schank",
  "item.minecraft.sugar": "zocker",
  "block.minecraft.cake": "kuch",
  "block.minecraft.white_bed": "wäisst bett",
  "block.minecraft.orange_bed": "oranget bett",
  "block.minecraft.magenta_bed": "magentat bett",
  "block.minecraft.light_blue_bed": "hellblot bett",
  "block.minecraft.yellow_bed": "gielt bett",
  "block.minecraft.lime_bed": "hellgréngt bett",
  "block.minecraft.pink_bed": "rosat bett",
  "block.minecraft.gray_bed": "grot bett",
  "block.minecraft.light_gray_bed": "hellgrot bett",
  "block.minecraft.cyan_bed": "turquoiset bett",
  "block.minecraft.purple_bed": "mooft bett",
  "block.minecraft.blue_bed": "blot bett",
  "block.minecraft.brown_bed": "brongt bett",
  "block.minecraft.green_bed": "gréngt bett",
  "block.minecraft.red_bed": "rout bett",
  "block.minecraft.black_bed": "schwaarzt bett",
  "item.minecraft.cookie": "kichelchen",
  "item.minecraft.filled_map": "kaart□#0",
  "item.minecraft.shears": "schéier",
  "item.minecraft.melon_slice": "melounescheif",
  "item.minecraft.dried_kelp": "gedréchent alg",
  "item.minecraft.pumpkin_seeds": "kürbiskären",
  "item.minecraft.melon_seeds": "melounekären",
  "item.minecraft.beef": "réit rëndfleesch",
  "item.minecraft.cooked_beef": "büfdeck",
  "item.minecraft.chicken": "réie poulet",
  "item.minecraft.cooked_chicken": "gebrodene poulet",
  "item.minecraft.rotten_flesh": "verfaultent fleesch",
  "item.minecraft.ender_pearl": "enderpärel",
  "item.minecraft.blaze_rod": "louerutt",
  "item.minecraft.ghast_tear": "ghasttréin",
  "item.minecraft.gold_nugget": "goldklompen",
  "item.minecraft.nether_wart": "netherwaarzel",
  "item.minecraft.potion": "net produzéierbaren dronk□ouni effekt",
  "item.minecraft.glass_bottle": "glasfläsch",
  "item.minecraft.spider_eye": "spannena",
  "item.minecraft.fermented_spider_eye": "fermentéiert spannena",
  "item.minecraft.blaze_powder": "louestëbs",
  "item.minecraft.magma_cream": "magmacrème",
  "block.minecraft.brewing_stand": "braustand",
  "block.minecraft.cauldron": "kessel",
  "item.minecraft.ender_eye": "endera",
  "item.minecraft.glistering_melon_slice": "blénkeg melounescheif",
  "item.minecraft.bat_spawn_egg": "flantermaus spawn ee",
  "item.minecraft.bee_spawn_egg": "beie spawn ee",
  "item.minecraft.blaze_spawn_egg": "lou spawn ee",
  "item.minecraft.cat_spawn_egg": "kaze spawn ee",
  "item.minecraft.cave_spider_spawn_egg": "höhlespann spawn ee",
  "item.minecraft.chicken_spawn_egg": "hong spawn ee",
  "item.minecraft.cod_spawn_egg": "cabillaud spawn ee",
  "item.minecraft.cow_spawn_egg": "kou spawn ee",
  "item.minecraft.creeper_spawn_egg": "creeper spawn ee",
  "item.minecraft.dolphin_spawn_egg": "delfin spawn ee",
  "item.minecraft.donkey_spawn_egg": "iesel spawn ee",
  "item.minecraft.drowned_spawn_egg": "erdronkene spawn ee",
  "item.minecraft.elder_guardian_spawn_egg": "grousse wiechter spawn ee",
  "item.minecraft.enderman_spawn_egg": "enderman spawn ee",
  "item.minecraft.endermite_spawn_egg": "endermite spawn ee",
  "item.minecraft.evoker_spawn_egg": "magier spawn ee",
  "item.minecraft.fox_spawn_egg": "fuuss spawn ee",
  "item.minecraft.ghast_spawn_egg": "ghast spawn ee",
  "item.minecraft.guardian_spawn_egg": "wiechter spawn ee",
  "item.minecraft.hoglin_spawn_egg": "hoglin spawn ee",
  "item.minecraft.horse_spawn_egg": "päerd spawn ee",
  "item.minecraft.husk_spawn_egg": "wüstenzombie spawn ee",
  "item.minecraft.llama_spawn_egg": "lama spawn ee",
  "item.minecraft.magma_cube_spawn_egg": "magmawierfel spawn ee",
  "item.minecraft.mooshroom_spawn_egg": "mooshroom spawn ee",
  "item.minecraft.mule_spawn_egg": "mauliesel spawn ee",
  "item.minecraft.ocelot_spawn_egg": "ozelot spawn ee",
  "item.minecraft.panda_spawn_egg": "panda spawn ee",
  "item.minecraft.parrot_spawn_egg": "papagei spawn ee",
  "item.minecraft.phantom_spawn_egg": "phantom spawn ee",
  "item.minecraft.pig_spawn_egg": "schwäi spawn ee",
  "item.minecraft.piglin_spawn_egg": "piglin spawn ee",
  "item.minecraft.pillager_spawn_egg": "plëmmert spawn ee",
  "item.minecraft.polar_bear_spawn_egg": "äisbier spawn ee",
  "item.minecraft.pufferfish_spawn_egg": "kugelfësch spawn ee",
  "item.minecraft.rabbit_spawn_egg": "kanéngche spawn ee",
  "item.minecraft.ravager_spawn_egg": "verwüster spawn ee",
  "item.minecraft.salmon_spawn_egg": "saumon spawn ee",
  "item.minecraft.sheep_spawn_egg": "schof spawn ee",
  "item.minecraft.shulker_spawn_egg": "shulker spawn ee",
  "item.minecraft.silverfish_spawn_egg": "sëlwerfëschelche spawn ee",
  "item.minecraft.skeleton_spawn_egg": "skelett spawn ee",
  "item.minecraft.skeleton_horse_spawn_egg": "skelettpäerd spawn ee",
  "item.minecraft.slime_spawn_egg": "schläim spawn ee",
  "item.minecraft.spider_spawn_egg": "spann spawn ee",
  "item.minecraft.squid_spawn_egg": "tëntefësch spawn ee",
  "item.minecraft.stray_spawn_egg": "vagabund spawn ee",
  "item.minecraft.strider_spawn_egg": "strider spawn ee",
  "item.minecraft.trader_llama_spawn_egg": "händlerlama spawn ee",
  "item.minecraft.tropical_fish_spawn_egg": "tropefësch spawn ee",
  "item.minecraft.turtle_spawn_egg": "schildkröte spawn ee",
  "item.minecraft.vex_spawn_egg": "plogeescht spawn ee",
  "item.minecraft.villager_spawn_egg": "awunner spawn ee",
  "item.minecraft.vindicator_spawn_egg": "lakai spawn ee",
  "item.minecraft.wandering_trader_spawn_egg": "nomaden händler spawn ee",
  "item.minecraft.witch_spawn_egg": "hex spawn ee",
  "item.minecraft.wither_skeleton_spawn_egg": "witherskelett spawn ee",
  "item.minecraft.wolf_spawn_egg": "wollef spawn ee",
  "item.minecraft.zoglin_spawn_egg": "zoglin spawn ee",
  "item.minecraft.zombie_spawn_egg": "zombie spawn ee",
  "item.minecraft.zombie_horse_spawn_egg": "zombiepäerd spawn ee",
  "item.minecraft.zombie_villager_spawn_egg": "zombieawunner spawn ee",
  "item.minecraft.zombified_piglin_spawn_egg": "zombifizéierte piglin spawn ee",
  "item.minecraft.experience_bottle": "erfarungsfläsch",
  "item.minecraft.fire_charge": "feierkugel",
  "item.minecraft.writable_book": "buch a fieder",
  "item.minecraft.written_book": "beschriwwent buch",
  "item.minecraft.emerald": "smaragd",
  "item.minecraft.item_frame": "kader",
  "block.minecraft.flower_pot": "blummendëppen",
  "item.minecraft.carrot": "muert",
  "item.minecraft.potato": "gromper",
  "item.minecraft.baked_potato": "gebake gromper",
  "item.minecraft.poisonous_potato": "vergëfte gromper",
  "item.minecraft.map": "eidel kaart",
  "item.minecraft.golden_carrot": "gëlle muert",
  "block.minecraft.skeleton_skull": "skelettkapp",
  "block.minecraft.wither_skeleton_skull": "witherskelettkapp",
  "block.minecraft.player_head": "spillerkapp",
  "block.minecraft.zombie_head": "zombiekapp",
  "block.minecraft.creeper_head": "creeperkapp",
  "block.minecraft.dragon_head": "draachenkapp",
  "item.minecraft.carrot_on_a_stick": "muerterutt",
  "item.minecraft.warped_fungus_on_a_stick": "verduerwenen champignon op engem bengel",
  "item.minecraft.nether_star": "netherstär",
  "item.minecraft.pumpkin_pie": "kürbiskuch",
  "item.minecraft.firework_rocket": "feierwierksrakéit",
  "item.minecraft.firework_star": "feierwierksstär",
  "item.minecraft.enchanted_book": "verzaubert buch",
  "item.minecraft.nether_brick": "netherzill",
  "item.minecraft.quartz": "netherquarz",
  "item.minecraft.tnt_minecart": "tnt-buggi",
  "item.minecraft.hopper_minecart": "triichterbuggi",
  "item.minecraft.prismarine_shard": "prismarineschierbel",
  "item.minecraft.prismarine_crystals": "prismarinekristall",
  "item.minecraft.rabbit": "réi kanéngchen",
  "item.minecraft.cooked_rabbit": "gebrode kanéngchen",
  "item.minecraft.rabbit_stew": "kanéngechersragoût",
  "item.minecraft.rabbit_foot": "kanéngecherspatt",
  "item.minecraft.rabbit_hide": "kanéngecherspelz",
  "item.minecraft.armor_stand": "rüstungsstänner",
  "item.minecraft.iron_horse_armor": "eise päerdsrüstung",
  "item.minecraft.golden_horse_armor": "gëlle päerdsrüstung",
  "item.minecraft.diamond_horse_armor": "diamante päerdsrüstung",
  "item.minecraft.leather_horse_armor": "lieder päerdsrüstung",
  "item.minecraft.lead": "léngt",
  "item.minecraft.name_tag": "schëld mam numm",
  "item.minecraft.command_block_minecart": "befehlsblockbuggi",
  "item.minecraft.mutton": "réit hämmelsfleesch",
  "item.minecraft.cooked_mutton": "gebrodent hämmelsfleesch",
  "block.minecraft.white_banner": "wäisse fändel",
  "block.minecraft.orange_banner": "orange fändel",
  "block.minecraft.magenta_banner": "magentae fändel",
  "block.minecraft.light_blue_banner": "hellbloe fändel",
  "block.minecraft.yellow_banner": "giele fändel",
  "block.minecraft.lime_banner": "hellgrénge fändel",
  "block.minecraft.pink_banner": "rosae fändel",
  "block.minecraft.gray_banner": "groe fändel",
  "block.minecraft.light_gray_banner": "hellgroe fändel",
  "block.minecraft.cyan_banner": "turquoise fändel",
  "block.minecraft.purple_banner": "mofe fändel",
  "block.minecraft.blue_banner": "bloe fändel",
  "block.minecraft.brown_banner": "bronge fändel",
  "block.minecraft.green_banner": "grénge fändel",
  "block.minecraft.red_banner": "roude fändel",
  "block.minecraft.black_banner": "schwaarze fändel",
  "item.minecraft.end_crystal": "endkristall",
  "item.minecraft.chorus_fruit": "chorusfruucht",
  "item.minecraft.popped_chorus_fruit": "geplatzte chorusfruucht",
  "item.minecraft.beetroot": "rout rommel",
  "item.minecraft.beetroot_seeds": "rout rommel som",
  "item.minecraft.beetroot_soup": "rout rommel zopp",
  "item.minecraft.dragon_breath": "draachenotem",
  "item.minecraft.splash_potion": "net produzéierbare worfdronk□ouni effekt",
  "item.minecraft.spectral_arrow": "spektral feil",
  "item.minecraft.tipped_arrow": "net hierstellbare gedränkte feil□ouni effekt",
  "item.minecraft.lingering_potion": "net produzéierbaren undauernden dronk□ouni effekt",
  "item.minecraft.shield": "schëld",
  "item.minecraft.elytra": "elytra",
  "item.minecraft.spruce_boat": "fiichtenholzboot",
  "item.minecraft.birch_boat": "bierkenholzboot",
  "item.minecraft.jungle_boat": "tropenholzboot",
  "item.minecraft.acacia_boat": "akazienholzboot",
  "item.minecraft.dark_oak_boat": "schwaarzeechenholzboot",
  "item.minecraft.totem_of_undying": "totem vun der onstierflechkeet",
  "item.minecraft.shulker_shell": "shulkerschuel",
  "item.minecraft.iron_nugget": "eiseklompen",
  "item.minecraft.knowledge_book": "buch vum wëssen",
  "item.minecraft.debug_stick": "debug-staf",
  "item.minecraft.music_disc_13": "schallplack□c418 - 13",
  "item.minecraft.music_disc_cat": "schallplack□c418 - cat",
  "item.minecraft.music_disc_blocks": "schallplack□c418 - blocks",
  "item.minecraft.music_disc_chirp": "schallplack□c418 - chirp",
  "item.minecraft.music_disc_far": "schallplack□c418 - far",
  "item.minecraft.music_disc_mall": "schallplack□c418 - mall",
  "item.minecraft.music_disc_mellohi": "schallplack□c418 - mellohi",
  "item.minecraft.music_disc_stal": "schallplack□c418 - stal",
  "item.minecraft.music_disc_strad": "schallplack□c418 - strad",
  "item.minecraft.music_disc_ward": "schallplack□c418 - ward",
  "item.minecraft.music_disc_11": "schallplack□c418 - 11",
  "item.minecraft.music_disc_wait": "schallplack□c418 - wait",
  "item.minecraft.music_disc_pigstep": "schallplack□lena raine - pigstep",
  "item.minecraft.trident": "dräizack□□an der haapthand:□+8 ugrëffsschued□-2.9 ugrëffsgeschwindegkeet",
  "item.minecraft.phantom_membrane": "phantomhaut",
  "item.minecraft.nautilus_shell": "nautilusschuel",
  "item.minecraft.heart_of_the_sea": "häerz vum mier",
  "item.minecraft.crossbow": "armbrust",
  "item.minecraft.suspicious_stew": "suspekt zopp",
  "block.minecraft.loom": "wiefstull",
  "item.minecraft.flower_banner_pattern": "fändelvirlag□blumm",
  "item.minecraft.creeper_banner_pattern": "fändelvirlag□creeper",
  "item.minecraft.skull_banner_pattern": "fändelvirlag□doudekapp",
  "item.minecraft.mojang_banner_pattern": "fändelvirlag□déngen",
  "item.minecraft.globe_banner_pattern": "fändelvirlag□globus",
  "item.minecraft.piglin_banner_pattern": "fändelvirlag□schnëss",
  "block.minecraft.composter": "komposter",
  "block.minecraft.barrel": "faass",
  "block.minecraft.smoker": "reecheruewen",
  "block.minecraft.blast_furnace": "schmelzuewen",
  "block.minecraft.cartography_table": "kaartendësch",
  "block.minecraft.fletching_table": "bouspanndësch",
  "block.minecraft.grindstone": "schläifsteen",
  "block.minecraft.lectern": "liespult",
  "block.minecraft.smithing_table": "schmadddësch",
  "block.minecraft.stonecutter": "steesee",
  "block.minecraft.bell": "klack",
  "block.minecraft.lantern": "lanter",
  "block.minecraft.soul_lantern": "séilelanter",
  "item.minecraft.sweet_berries": "séissbieren",
  "block.minecraft.campfire": "lagerfeier",
  "block.minecraft.soul_campfire": "séilelagerfeier",
  "block.minecraft.shroomlight": "champignonluucht",
  "item.minecraft.honeycomb": "hunnegwab",
  "block.minecraft.bee_nest": "beiennascht",
  "block.minecraft.beehive": "beiestack",
  "item.minecraft.honey_bottle": "hunnegfläsch",
  "block.minecraft.honey_block": "hunnegblock",
  "block.minecraft.honeycomb_block": "hunnegwabeblock",
  "block.minecraft.lodestone": "leetsteen",
  "block.minecraft.netherite_block": "netheriteblock",
  "block.minecraft.ancient_debris": "anticke schrott",
  "block.minecraft.target": "zielblock",
  "block.minecraft.crying_obsidian": "kräischenden obsidian",
  "block.minecraft.blackstone": "schwaarzsteen",
  "block.minecraft.blackstone_slab": "schwaarzsteeplack",
  "block.minecraft.blackstone_stairs": "schwaarzsteentrap",
  "block.minecraft.gilded_blackstone": "gëllenen schwaarzsteen",
  "block.minecraft.polished_blackstone": "poléierten schwaarzsteen",
  "block.minecraft.polished_blackstone_slab": "poléiert schwaarzsteeplack",
  "block.minecraft.polished_blackstone_stairs": "poléiert schwaarzsteentrap",
  "block.minecraft.chiseled_polished_blackstone": "gemeesselte poléierte schwarzsteen",
  "block.minecraft.polished_blackstone_bricks": "poléiert schwarzsteenzillen",
  "block.minecraft.polished_blackstone_brick_slab": "poléiert schwaarzsteenzilleplack",
  "block.minecraft.polished_blackstone_brick_stairs": "poléiert schwaarzsteenzillentrap",
  "block.minecraft.cracked_polished_blackstone_bricks": "rësseg poléiert schwarzsteenzillen",
  "block.minecraft.respawn_anchor": "respawn anker",
}
export const lb_lu = items; 
